import React, { useEffect, useState } from "react";
import { FC } from "react";
import { getBrowserHelperImage } from "./helper";
import { browserName } from "react-device-detect";
import styles from "./permissionModal.module.scss";
import { createPortal } from "react-dom";

export type CameraPermissionModalConfig = {
  enabled?: boolean;
  modalTitle?: string;
  modalText?: string;
  modalButton?: string;
  onRetry?: () => void;
};
export type CameraPermissionModalProps = {
  enableModel: boolean;
  cameraPermissionModalConfig?: CameraPermissionModalConfig;
  retry: () => void;
};

const CameraPermissionModal: FC<CameraPermissionModalProps> = ({
  enableModel,
  cameraPermissionModalConfig,
  retry,
}) => {
  const [cameraPermissionModalCustom, setCameraPermissionModalCustom] =
    useState<CameraPermissionModalConfig>({
      enabled: true,
      modalTitle: "Camera Permission Needed",
      modalText:
        "This application needs access to the camera to scan your medical insurance card. Please allow access to the camera.",
      modalButton: "Try Again",
    });

  useEffect(() => {
    if (cameraPermissionModalConfig) {
      setCameraPermissionModalCustom((prev) => ({
        ...prev,
        ...cameraPermissionModalConfig,
      }));
    }
  }, [cameraPermissionModalConfig]);

  if (!enableModel) {
    return <></>;
  }

  return createPortal(
    <div className={styles.scanErrorModal}>
      <h2 className={styles.scanErrorTitle}>
        {cameraPermissionModalCustom.modalTitle}
      </h2>
      <p>{cameraPermissionModalCustom.modalText}</p>
      <video controls autoPlay loop muted width="400">
        <source src={getBrowserHelperImage(browserName)} type="video/mp4" />
        Sorry, your browser doesn&apos;t support embedded videos.
      </video>

      <div className={styles.scanErrorButtonContainer}>
        <button
          className={`${styles.scanErrorButton} ${styles.scanErrorButtonPrimary}`}
          onClick={retry}
        >
          {cameraPermissionModalCustom.modalButton}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default CameraPermissionModal;
